import { RootService } from './../root/home/root.service';
import { OnBoardingService } from './../on-boarding/on-boarding.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class OnBoardingGuard implements CanActivate {
  constructor(private router: Router, private rootService: RootService, private onBoardingService: OnBoardingService) {}

  canActivate(): boolean {
    if (!this.rootService.get().isOnboardingDone) {
      this.router.navigate(['on-boarding']);
      return false;
    }
    return true;
  }
}
